import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import IconButton from "@mui/material/IconButton";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import ThemeController from "examples/ThemeController";

function Sidenav({ color,themeValue, brand, brandName, routes,theme, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;
  const location = useLocation();
  const collapseName = location.pathname.replace("/", "");
  const toggleNavbar = () => setMiniSidenav(dispatch,!miniSidenav);
  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }
    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location,transparentSidenav,whiteSidenav]);

  const renderRoutes = routes.map(({ name, icon, key, route }) => (
    <NavLink key={key} to={route}>
      <SidenavCollapse name={name} icon={icon} active={key === collapseName} />
    </NavLink>
  ));


  const { palette } = theme;
  const { transparent, gradients, white, background } = palette;
  let backgroundValue = darkMode
    ? background.sidenav
    : gradients.dark.main
  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  return (
    <div>
      <MDBox width="100%" height="40px" position="fixed" top={0} left={0} zIndex={1300} sx={{ backgroundColor: backgroundValue }}>
        <MDBox position="relative" width="100%" height="100%" display="flex" alignItems="center" justifyContent="space-between" px={2}>
          <MDBox display="flex" alignItems="center">
            <IconButton color={textColor} onClick={toggleNavbar}>
              <Icon fontSize="small">menu</Icon>
            </IconButton>
            <MDBox component={NavLink} to="/" alignItems="center" sx={{ pl: 2 }}>
              <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
                {brandName}
              </MDTypography>
            </MDBox>
          </MDBox>
          <ThemeController />
        </MDBox>
      </MDBox>
    <SidenavRoot {...rest} variant="permanent" ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}>
      <div style={{padding:"30px"}}></div>
      <List>
        {renderRoutes}
      </List>
    </SidenavRoot>
    </div>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
